import { shallowEqual } from 'react-redux';

import { Alert, Spacer } from '@zillow/constellation';
import { Box, Text } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';

import accessUtils from '../../../../utils/accessUtils';

import LeaseDurationFieldSetSelect from './LeaseDurationFormFieldSelect';
import PropertyDescriptionFormField from '../../../../components/WizardModularListing/DescribeProperty/components/PropertyDescriptionFormField';
import MonthlyRentFormField from '../../../../components/WizardModularListing/MonthlyRent/components/MonthlyRentFormField';
import SecurityDepositFormField from '../../SecurityDeposit/components/SecurityDepositFormField';
import DateAvailableFormField from '../../../../components/WizardModularListing/WhenIsPropertyAvailable/components/DateAvailableFormField';
import LeaseTermsFormField from '../../../../components/WizardModularListing/LeaseTerms/components/LeaseTermsFormField';
import SchedulerFormField from '../../../../components/WizardModularListing/AvailableToShowProperty/components/SchedulerFormField';
import SpecialOffers from '../../../../components/WizardModularListing/SpecialOffers';

import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const FormSectionContainer = () => {
  const { appConfig, cookieEnabledServices } = useSelector(
    (state) => ({
      appConfig: state.app.appConfig,
      cookieEnabledServices: state.app.cookieEnabledServices,
    }),
    shallowEqual,
  );

  const isLegacyTourDisabled = accessUtils.isLegacyTourDisabled({ appConfig, cookieEnabledServices });

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      <WizardHeading level={1} textStyle="heading-sm">
        Are these details still accurate?
      </WizardHeading>
      <WizardBody>Review and update any information that has changed since you last listed this property.</WizardBody>

      <Box
        css={{
          display: 'grid',
          gridTemplateColumns: { base: 'repeat(12, 1fr)', lgDown: 'repeat(6, 1fr)' },
          columnGap: '400',
          marginBottom: '800',
        }}
      >
        <Box css={{ display: 'grid', gridColumnEnd: 'span 6', marginBottom: { base: '800', lg: 0 } }}>
          <MonthlyRentFormField isRelistingFieldset={true} />
        </Box>
        <Box css={{ display: 'grid', gridColumnEnd: 'span 6' }}>
          <SecurityDepositFormField showOneMonthsRentButton={false} />
        </Box>
      </Box>

      <Box
        css={{
          display: 'grid',
          gridTemplateColumns: { base: 'repeat(12, 1fr)', lgDown: 'repeat(6, 1fr)' },
          columnGap: '400',
          marginBottom: '800',
        }}
      >
        <Box css={{ display: 'grid', gridColumnEnd: 'span 6', marginBottom: { base: '800', lg: 0 } }}>
          <LeaseDurationFieldSetSelect />
        </Box>
        <Box css={{ display: 'grid', gridColumnEnd: 'span 6' }}>
          <DateAvailableFormField showNextMonthButton={false} />
        </Box>
      </Box>

      <Spacer marginBottom="lg">
        <LeaseTermsFormField isRelistingFieldset={true} />
      </Spacer>

      <Spacer marginBottom="lg">
        <PropertyDescriptionFormField isRelistingFieldset={true} />
      </Spacer>

      <Spacer marginBottom="lg">
        {!isLegacyTourDisabled ? (
          <SchedulerFormField hideLabel={true} textStyle="body-sm-bold" />
        ) : (
          <>
            <Text textStyle="body-bold">Tour availability</Text>

            <Alert
              marginTop="sm"
              body={
                <Text textStyle="body-sm">
                  After you publish your listing, you&apos;ll be able to set your availability for tours.
                </Text>
              }
            />
          </>
        )}
      </Spacer>

      <Spacer marginBottom="lg">
        <SpecialOffers isRelistingFieldset={true} />
      </Spacer>
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
